"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOpenEndedQuestion = void 0;
const randomString_1 = require("./randomString");
function createOpenEndedQuestion(settings, id = (0, randomString_1.randomString)()) {
    return Object.assign({ id, questionType: "open-ended", contentType: "text/plain", templateId: "", label: "", required: false, allowComments: false, commentAppeal: "" }, settings);
}
exports.createOpenEndedQuestion = createOpenEndedQuestion;
//# sourceMappingURL=createOpenEndedQuestion.js.map